export const PAGE_ACTION_IDS = {
  MOVE_SUBCATEGORY: 'moveSubcategory',
  REMIX_CONTENT: 'remixContent',
  UPDATE_DOMAIN: 'updateDomain',
  VIEW_DETAILS: 'viewDetails',
  DELETE_PERSONALIZED_CONTENT: 'deletePersonalizedContent'
};